import { render, staticRenderFns } from "./ReviewListPaginatedForSimulation.vue?vue&type=template&id=eade8b02&scoped=true&lang=pug&"
import script from "./ReviewListPaginatedForSimulation.vue?vue&type=script&lang=coffee&"
export * from "./ReviewListPaginatedForSimulation.vue?vue&type=script&lang=coffee&"
import style0 from "./ReviewListPaginatedForSimulation.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ReviewListPaginatedForSimulation.vue?vue&type=style&index=1&id=eade8b02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eade8b02",
  null
  
)

component.options.__file = "ReviewListPaginatedForSimulation.vue"
export default component.exports